





















import Vue from 'vue';
export default Vue.extend({
    data() {
        return {
            transitionName: 'slide-left',
        };
    },
    computed: {
        snackbar: {
            get() {
                return this.$store.getters.snackBar;
            },
        },
        loading: {
            get() {
                return this.$store.getters.loading;
            },
        },
    },
    created() {
        this.$router.beforeEach((to, from, next) => {
            let toDepth = to.path.split('/').length;
            let fromDepth = from.path.split('/').length;
            if (toDepth === fromDepth) {
                toDepth = to.meta.index;
                fromDepth = from.meta.index;
            }
            this.transitionName =
                toDepth < fromDepth ? 'slide-right' : 'slide-left';
            next();
        });
    },
});
